import styledFlexboxGrid from 'styled-flexbox-grid';

export enum Color {
  white = '#ffffff',
  grey = '#7d7e98',
  black = '#2b2738',
  green = '#0d7461',
  lime = '#00904e',
  navy = '#212852',
  blue = '#2f6cb3',
  lightBlue = '#cdeae9',
  peach = '#f9f9fc',
  orange = '#f4633a',
  claret = '#9d2c21',
}

export enum FontWeight {
  light = 200,
  regular = 400,
  medium = 500,
  semiBold = 600,
  bold = 700,
  black = 900,
}

export enum StyledFlexboxBreakpoints {
  xxs = 0,
  xs = 320,
  s = 576,
  m = 768,
  l = 992,
  xl = 1200,
  xxl = 1440,
}

interface StyledFlexboxGrid {
  rowWidth: number;
  gutter: string;
  columnCount: number;
  breakpoints: {
    xxs: StyledFlexboxBreakpoints;
    xs: StyledFlexboxBreakpoints;
    s: StyledFlexboxBreakpoints;
    m: StyledFlexboxBreakpoints;
    l: StyledFlexboxBreakpoints;
    xl: StyledFlexboxBreakpoints;
    xxl: StyledFlexboxBreakpoints;
  }
}

interface ThemeInterface {
  fontFamily: string;
  fonts: {
    default: string;
  };
  fontWeight: {
    light: FontWeight;
    regular: FontWeight;
    medium: FontWeight;
    semiBold: FontWeight;
    bold: FontWeight;
    black: FontWeight;
  };
  slotHoverOutlineColor: string;
  color: {
    white: Color;
    black: Color;
    green: Color;
    lime: Color;
    navy: Color;
    blue: Color;
    lightBlue: Color;
    peach: Color;
    grey: Color;
    orange: Color;
    claret: Color;
  };
  container: string;
  styledFlexboxGrid: StyledFlexboxGrid;
}

const mainGrid: StyledFlexboxGrid = styledFlexboxGrid({
  rowWidth: 1440,
  gutter: '12px',
  columnCount: 12,
  breakpoints: {
    xxs: StyledFlexboxBreakpoints.xxs,
    xs: StyledFlexboxBreakpoints.xs,
    s: StyledFlexboxBreakpoints.s,
    m: StyledFlexboxBreakpoints.m,
    l: StyledFlexboxBreakpoints.l,
    xl: StyledFlexboxBreakpoints.xl,
    xxl: StyledFlexboxBreakpoints.xxl,
  }
});

const theme: ThemeInterface = {
  fontFamily: `'DINNextLTPro'`,
  fonts: {
    default: `sans-serif`,
  },
  slotHoverOutlineColor: '#87dbe6',
  color: {
    blue: Color.blue,
    lightBlue: Color.lightBlue,
    white: Color.white,
    black: Color.black,
    green: Color.green,
    claret: Color.claret,
    lime: Color.lime,
    navy: Color.navy,
    peach: Color.peach,
    grey: Color.grey,
    orange: Color.orange,
  },
  fontWeight: {
    light: FontWeight.light,
    regular: FontWeight.regular,
    medium: FontWeight.medium,
    semiBold: FontWeight.semiBold,
    bold: FontWeight.bold,
    black: FontWeight.black,
  },
  container: '980px',
  // breakpoints - changing default breakpoints (https://styled-system.com/responsive-styles#using-objects)
  // will not work because of how we use styled-system functions:
  // $(space({ m: ['10px', '20px'] })) vs ${space}
  styledFlexboxGrid: mainGrid
};

export default theme;
